<template lang="pug">
.form-bonus.center(@click.stop="")

  
  .info-general-card
    .info-general-grid
      .info-general-item
        .info-general-icon
          span.material-symbols-outlined local_activity
        .info-general-content
          .info-general-label Bono
          .info-general-value {{ dataOriginal.bonus }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined call
        .info-general-content
          .info-general-label Teléfono
          .info-general-value {{ dataOriginal.phone }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined label
        .info-general-content
          .info-general-label Tipo
          .info-general-value {{ translateType(dataOriginal.type) }}

      .info-general-item(v-if="dataOriginal.changeId")
        .info-general-icon
          span.material-symbols-outlined swap_horiz
        .info-general-content
          .info-general-label ID Cambio
          .info-general-value {{ dataOriginal.changeId }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined description
        .info-general-content
          .info-general-label Motivo
          .info-general-value {{ dataOriginal.reason }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined payments
        .info-general-content
          .info-general-label Valor Original
          .info-general-value {{ money(dataOriginal.originalValue) }}

      .info-general-item(v-if="dataOriginal.promotionPercent > 0")
        .info-general-icon
          span.material-symbols-outlined percent
        .info-general-content
          .info-general-label % Promoción
          .info-general-value {{ dataOriginal.promotionPercent }}%

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined remove_circle_outline
        .info-general-content
          .info-general-label Usado
          .info-general-value {{ money(dataOriginal.usedValue) }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined account_balance_wallet
        .info-general-content
          .info-general-label Disponible
          .info-general-value {{ money(dataOriginal.remainingValue) }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined info
        .info-general-content
          .info-general-label Estado
          .info-general-value.capitalize {{ translateStatus(dataOriginal.status) }}

      .info-general-item.info-general-item--full
        .info-general-icon
          span.material-symbols-outlined shopping_bag
        .info-general-content
          .info-general-label Órdenes vinculadas
          .info-general-value(v-if="linkedOrderIds.length") {{ linkedOrderIds.join(', ') }}
          .info-general-empty(v-else) Ninguna orden aún

  shProductsTable(
    v-if="dataOriginal.type === 'refund'"
    :products="dataOriginal.products"
    :brand="dataOriginal.brand"
    title="Productos del Bono"
  )

  h3(v-if="dataOriginal.transactions && dataOriginal.transactions.length > 0") Historial de Uso
  .transactions-container(v-if="dataOriginal.transactions && dataOriginal.transactions.length > 0")
    .transaction(v-for="(transaction, index) in dataOriginal.transactions" :key="index")
      .transaction-number {{ index + 1 }}.
      .transaction-order Orden: {{ transaction.order }}
      .transaction-value {{ money(transaction.valueUsed) }}
      .transaction-date {{ dateTime(transaction.usedAt) }}

  .history-card
    table.history-table
      thead
        tr
          th Acción
          th Usuario
          th Fecha
      tbody
        tr(v-if="dataOriginal.createdBy")
          td
            span.material-symbols-outlined add_circle
            | Creado
          td
            shNameUser(:dni="dataOriginal.createdBy")
          td {{ dateName(dataOriginal.createdAt) }} - {{ time(dataOriginal.createdAt) }}
        tr(v-if="dataOriginal.approvedBy")
          td
            span.material-symbols-outlined check_circle
            | Aprobado
          td
            shNameUser(:dni="dataOriginal.approvedBy")
          td {{ dateName(dataOriginal.approvedAt) }} - {{ time(dataOriginal.approvedAt) }}
        tr(v-if="dataOriginal.declinedBy")
          td
            span.material-symbols-outlined cancel
            | Rechazado
          td
            shNameUser(:dni="dataOriginal.declinedBy")
          td {{ dateName(dataOriginal.declinedAt) }} - {{ time(dataOriginal.declinedAt) }}

  form(@submit.prevent="" autocomplete="off" v-if="dataOriginal.type === 'refund'")
    h3 Envío de devolución

    .input-container.arrow
      select.select(v-model="dataForm.conveyorCustomer" autocomplete="ño")
        option(value="")
        option(v-for="conveyor in conveyors" :value="conveyor" :key="conveyor") {{ capitalize(conveyor) }}
      label.label(:class="{ show: dataForm.conveyorCustomer }") Transportadora del cliente

    .input-container
      input.input(v-model="dataForm.tracking" autocomplete="ño")
      label.label(:class="{ show: dataForm.tracking }") Número de guía

    .input-container
      input.input(v-model.number="dataForm.packageCost" type="number" min="0" max="50000" step="1" autocomplete="ño")
      label.label(:class="{ show: dataForm.packageCost || dataForm.packageCost === 0 }") Costo del paquete

    .info-general-item.info-general-item--full(v-if="dataOriginal.packReceived")
      .info-general-icon
        span.material-symbols-outlined inventory_2
      .info-general-content
        .info-general-label Paquete recibido
        .info-general-value
          shNameUser(:dni="dataOriginal.packReceivedBy")
          span  — {{ dateName(dataOriginal.packReceivedAt) }} {{ time(dataOriginal.packReceivedAt) }}

    shActionButton(:isForm="true" text="Actualizar envío" textRunning="Actualizando" :action="sendForm")

  form(@submit.prevent="" autocomplete="off")
    h3 Editar Observación
    
    .input-container
      textarea.input(v-model="dataForm.observation" autocomplete="ño" rows="4")
      label.label(:class="{ show: dataForm.observation }") Observación

    shActionButton(:isForm="true" text="Actualizar" textRunning="Actualizando" :action="sendForm")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlBonus from '@/graphql/bonus'
import shNameUser from '@/components/elements/NameUser'
import shProductsTable from '@/components/elements/ProductsTable'

export default {
  name: 'FormBonus',

  mixins: [mForm, mFilters, mDB],

  components: { shNameUser, shProductsTable },

  props: {
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        bonus: '',
        observation: '',
        conveyorCustomer: '',
        tracking: '',
        packageCost: 0
      },
      resolver: 'bonus',
      key: 'bonus',
      gql: gqlBonus,
      delete: ['createdAt', 'reason', 'updatedAt', 'approvedAt', 'declinedAt', 'products', 'transactions']
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  computed: {
    linkedOrderIds () {
      const txs = this.dataOriginal && this.dataOriginal.transactions
      if (!txs || !txs.length) return []
      return [...new Set(txs.map(t => t.order).filter(Boolean))]
    },

    conveyors () {
      return this.$store.state.variables.conveyors || []
    }
  },

  methods: {
    sendForm () {
      this.updateBonus()
    },

    updateBonus () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    translateStatus (status) {
      const statusMap = {
        'created': 'Creado',
        'approved': 'Aprobado',
        'declined': 'Rechazado'
      }
      return statusMap[status] || status
    },

    translateType (type) {
      const typeMap = {
        'refund': 'Reembolso',
        'change': 'Cambio',
        'manual': 'Manual'
      }
      return typeMap[type] || type
    },

  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) {
          this.dataForm.bonus = this.dataOriginal.bonus
          this.dataForm.observation = this.dataOriginal.observation || ''
          this.dataForm.conveyorCustomer = this.dataOriginal.conveyorCustomer || ''
          this.dataForm.tracking = this.dataOriginal.tracking || ''
          this.dataForm.packageCost = this.dataOriginal.packageCost || 0
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-bonus
  position relative

.info-general-card
  background white
  border-radius 1em
  padding 2.5em
  margin-bottom 1.5em

.info-general-title
  font-size 1.2em
  font-weight 600
  color #1a1a1a
  margin 0 0 1.5em 0
  text-align center

.info-general-grid
  display grid
  grid-template-columns 1fr 1fr
  gap 2.2em

.info-general-item
  display flex
  align-items center
  gap 1.2em
  text-align left

.info-general-icon
  width 3.4em
  height 3.4em
  border-radius 50%
  background #f0f0f0
  display flex
  align-items center
  justify-content center
  flex-shrink 0

.info-general-icon .material-symbols-outlined
  font-size 1.6em
  color #888

.info-general-content
  display flex
  flex-direction column
  gap 0.4em
  text-align left

.info-general-label
  font-size 0.9em
  color #888
  line-height 1

.info-general-value
  font-size 1.15em
  font-weight 600
  color #1a1a1a

.info-general-item--full
  grid-column 1 / -1

.info-general-empty
  font-size 1.05em
  color #888
  font-weight 500

.transactions-container
  margin 1em 0

.transaction
  display flex
  justify-content space-between
  padding 0.5em
  border-bottom 1px solid rgba(255,255,255,0.1)

.transaction-number
  flex-basis 5%

.transaction-order
  flex-basis 30%

.transaction-value
  flex-basis 30%
  text-align right

.transaction-date
  flex-basis 35%
  text-align right
</style>




// WEBPACK FOOTER //
// src/components/pages/bonus/Form.vue